export default "__VITE_ASSET__BwGHLrIi__"